import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { Flex } from '../../../components/common/atom/Layout';
import { Button } from '../../../components/common/atom/Button';
import { Text } from '../../../components/common/atom/Text';
import { Padding } from '../../../components/common/atom/Padding';
import { OnlyInput } from '../../../components/common/atom/Input';
import { ShortForm } from '../Detail/OrderDetailShortForm';
import OrderPaybackRefundInfo from '../Item/OrderPaybackRefundInfo';

import Reducer from '../../../modules/reducers/Reducer';
import { getBankAccount } from '../../../lib/api/GetBankAccountHolder';
import { doRefundPayment } from './RefundAPI';
import Loading from '../../../components/common/organism/Loading';
import * as PATH from '../../../lib/routes/path';
import { STATUS_MESSAGE } from '../../../lib/Error';
import { useAnalytics } from '../../../Hooks/useAnalytics';
import { isProductionEnv } from '../../../lib/util/Environment';

function doShowRefundBankInfo(order, setBankObject, onChangeBankObject) {
  if (order.paymentMethod !== 'VIRTUAL_ACCOUNT') return;
  if (order.status === 'PENDING_DEPOSIT') return;

  return (
    <Padding top={20}>
      <OrderPaybackRefundInfo
        onChange={(e) => onChangeBankObject(e)}
        onSelectAccount={(e) =>
          setBankObject({
            name: 'bankCode',
            value: e.value,
          })
        }
      />
    </Padding>
  );
}

function doRefund(
  id,
  refundReason,
  bankHolder,
  bankAccount,
  bankCode,
  setLoading,
  setRedirect,
) {
  const { gaEnhancedEcommerce } = useAnalytics();
  setLoading(true);

  if (window.confirm('환불 하시겠습니까?') === true) {
    doRefundPayment({
      id,
      amount: 0, // amount 0 : 전액 환불
      reason: refundReason,
      holder: bankHolder,
      account: bankAccount,
      bankCode,
    }).then((response) => {
      setLoading(false);
      setRedirect(true);
      if (isProductionEnv)
        gaEnhancedEcommerce({ data: response, isRefund: true });
    });
  } else {
    setLoading(false);
  }
}

function doRefundForVirtualAccount(
  id,
  refundReason,
  bankHolder,
  bankAccount,
  bankCode,
  setLoading,
  setRedirect,
) {
  setLoading(true);

  getBankAccount({ bankCode, bankAccount }).then((response) => {
    const result = { ...response.data };
    const message = STATUS_MESSAGE.order.refund;
    if (result.code !== 0) {
      alert(message.REQUIRE_VALIDATION);
      setLoading(false);
      return;
    }
    if (result.response.accountHolder !== bankHolder) {
      alert(message.REQUIRE_VALIDATION);
      setLoading(false);
      return;
    }
    doRefund(
      id,
      refundReason,
      bankHolder,
      bankAccount,
      bankCode,
      setLoading,
      setRedirect,
    );
  });
}

function doShowRefundButton(
  order,
  refundReason,
  bankHolder,
  bankAccount,
  bankCode,
  setLoading,
  setRedirect,
) {
  if (order.status === 'REFUNDED') return;
  if (
    order.paymentMethod === 'VIRTUAL_ACCOUNT' &&
    order.status !== 'PENDING_DEPOSIT'
  ) {
    return (
      <Flex justifyContent="space-around" padding="1.25rem 0 0">
        <Button
          color="brownGrey"
          onClick={() =>
            doRefundForVirtualAccount(
              order.id,
              refundReason,
              bankHolder,
              bankAccount,
              bankCode,
              setLoading,
              setRedirect,
            )
          }
          style={{ width: '5.5rem' }}
        >
          확인
        </Button>
      </Flex>
    );
  }

  return (
    <Flex justifyContent="space-around" padding="1.25rem 0 0">
      <Button
        color="brownGrey"
        onClick={() =>
          doRefund(
            order.id,
            refundReason,
            bankHolder,
            bankAccount,
            bankCode,
            setLoading,
            setRedirect,
          )
        }
        style={{ width: '5.5rem' }}
      >
        확인
      </Button>
    </Flex>
  );
}

const RefundView = ({ data }) => {
  const order = { ...data };
  const [redirect, setRedirect] = useState(false);
  const [refundReason, setRefundReason] = useState('');
  const [
    BankObject,
    setBankObject,
    onChangeBankObject,
    setBankObjectAll,
  ] = Reducer({
    bankCode: '',
    bankHolder: '',
    bankAccount: '',
  });
  const { bankCode, bankHolder, bankAccount } = BankObject;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setBankObjectAll({
      object: {
        bankCode: order.refundBank,
        bankHolder: order.refundHolder,
        bankAccount: order.refundAccount,
      },
    });
  }, [data]);

  return (
    <>
      {redirect && <Redirect to={PATH.MYPAGE_ORDER} />}
      {loading ? (
        <Loading />
      ) : (
        <Flex column alignItems="stretch" padding="0 0 1.875rem">
          <Flex justifyContent="flex-start">
            <Text size="14" weight="medium">
              주문상품
            </Text>
            <Text
              size={12}
              color="orangePink"
              style={{ marginLeft: '0.313rem' }}
            >
              총 1건
            </Text>
          </Flex>
          <ShortForm order={order} />
          <Text size={14} weight="medium" style={{ marginBottom: '0.313rem' }}>
            취소 사유
          </Text>
          <OnlyInput
            placeholder={'취소 사유를 입력해주세요.'}
            value={refundReason}
            onChange={(e) => setRefundReason(e.target.value)}
            valid
          />
          {doShowRefundBankInfo(
            order,
            bankCode,
            bankHolder,
            bankAccount,
            setBankObject,
            onChangeBankObject,
          )}
          {doShowRefundButton(
            order,
            refundReason,
            bankHolder,
            bankAccount,
            bankCode,
            setLoading,
            setRedirect,
          )}
        </Flex>
      )}
    </>
  );
};

export default React.memo(RefundView);
